<template>
  <div class="card mgt-20px" v-if="positionnement">
    <header class="header-card">
      <p> {{$t('domiciliationBancairePositionCheque.title')}}  </p>
    </header>
    <div class="card-content">
       <div class="columns cheque is-marginless is-vcentered">
            <div class="card column is-paddingless" id="cheque">
                <header class="header-card has-text-weight-bold has-text-link">
                    {{$t('domiciliationBancairePositionCheque.cheque')}}
                </header>
                <div class="card-content columns is-variable is-2 is-marginless is-multiline">
                    <canvas id="c" width="2500" height="500">
                    </canvas>
                    <div class="column is-8">
                        <div class="borderBottom element" id="montantLettre1">
                            <span class="pdl-10px">
                                {{$t('domiciliationBancairePositionCheque.debutMontantLettre')}}
                            </span>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="borderBottom element" id="montantChiffre">
                            <span class="montantChiffre">
                                {{$t('domiciliationBancairePositionCheque.montantChiffre')}}
                            </span>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="borderBottom element has-text-right" id="montantLettre2">
                            <span class="pdl-10px">
                                {{$t('domiciliationBancairePositionCheque.finMontantLettre')}}
                            </span>
                        </div>
                    </div>
                    <div class="column is-offset-1 is-3 ">
                        <div class="borderBottom element" id="lieu">
                            <span class="pdl-20px ">
                                {{$t('domiciliationBancairePositionCheque.lieu')}}
                            </span>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="borderBottom element " id="destinataire">
                            <span class="pdl-10px">
                                {{$t('domiciliationBancairePositionCheque.ordreCheque')}}
                            </span>
                        </div>
                    </div>
                    <div class="column is-offset-1 is-3">
                        <div class="borderBottom element " id="date">
                            <span class="pdl-20px ">
                                {{$t('domiciliationBancairePositionCheque.date')}}
                            </span>
                        </div>
                    </div>
                </div>
                <footer>
                </footer>
            </div>
        </div>
        <div class="columns is-multiline mgt-20px">
            <b-field :label="$t('domiciliationBancairePositionCheque.debutMontantLettre')"
                class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.montantEnLettreX1"
                            :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency  v-model="positionnement.montantEnLettreY1"
                            :disabled="disabled">
                        </input-currency >
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.finMontantLettre')"
                class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.montantEnLettreX2"
                            :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.montantEnLettreY2"
                            :disabled="disabled">
                        </input-currency>
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.montantChiffre')"
                class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.montantEnChiffreX"
                            :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.montantEnChiffreY"
                            :disabled="disabled">
                        </input-currency >
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.ordreCheque')"
                class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.ordreX" :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.ordreY" :disabled="disabled">
                        </input-currency >
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.lieu')" class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.lieuX" :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.lieuY" :disabled="disabled">
                        </input-currency >
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.date')" class="column is-3">
                <div class="columns is-vcentered is-marginless">
                    <span class="column is-narrow is-paddingless has-text-danger">
                        {{$t('domiciliationBancairePositionCheque.x')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.dateX" :disabled="disabled">
                        </input-currency >
                    </div>
                    <span class="column is-narrow is-paddingless has-text-cumulFonce3">
                        {{$t('domiciliationBancairePositionCheque.y')}} :
                    </span>
                    <div class="column pdt-0  pdb-0 ">
                        <input-currency v-model="positionnement.dateY" :disabled="disabled">
                        </input-currency >
                    </div>
                </div>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.margeBas')"
                class="column is-3">
                <input-currency v-model="positionnement.margeBas" :disabled="disabled">
                </input-currency>
            </b-field>
            <b-field :label="$t('domiciliationBancairePositionCheque.taillePolice')"
                class="column is-3">
                <input-currency  v-model="positionnement.taillePolice" :disabled="disabled">
                </input-currency >
            </b-field>
        </div>
    </div>
  </div>
</template>
<script>
import inputCurrency from '@/components/general/inputCurrency';

export default {
  props: {
    positionnement: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    inputCurrency,
  },
  methods: {
    canvas_arrow(context, fromx, fromy, tox, toy) {
      const headlen = 10; // length of head in pixels
      const dx = tox - fromx;
      const dy = toy - fromy;
      const angle = Math.atan2(dy, dx);
      context.moveTo(fromx, fromy);
      context.lineTo(tox, toy);
      context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6),
        toy - headlen * Math.sin(angle - Math.PI / 6));
      context.moveTo(tox, toy);
      context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6),
        toy - headlen * Math.sin(angle + Math.PI / 6));
    },
  },
  mounted() {
    const ctx = document.getElementById('c').getContext('2d');
    const bodyRect = document.body.getBoundingClientRect();
    const cheque = document.getElementById('cheque').getBoundingClientRect();
    const offsetVerti = cheque.top - bodyRect.top;
    const offsetHori = cheque.left - bodyRect.left;

    const montantLettre1 = document.getElementById('montantLettre1').getBoundingClientRect();
    const montantLettre2 = document.getElementById('montantLettre2').getBoundingClientRect();
    const montantChiffre = document.getElementById('montantChiffre').getBoundingClientRect();
    const destinataire = document.getElementById('destinataire').getBoundingClientRect();
    const lieu = document.getElementById('lieu').getBoundingClientRect();
    const date = document.getElementById('date').getBoundingClientRect();

    ctx.beginPath();
    ctx.strokeStyle = '#0074c7';
    this.canvas_arrow(ctx, montantLettre1.left - offsetHori, montantLettre1.bottom - offsetVerti,
      montantLettre1.left - offsetHori, cheque.top - offsetVerti);
    this.canvas_arrow(ctx, montantLettre2.right - offsetHori, montantLettre2.bottom - offsetVerti,
      montantLettre2.right - offsetHori, cheque.top - offsetVerti);
    this.canvas_arrow(ctx, destinataire.left - offsetHori, destinataire.bottom - offsetVerti,
      destinataire.left - offsetHori, cheque.top - offsetVerti);
    this.canvas_arrow(ctx, lieu.left - offsetHori, lieu.bottom - offsetVerti,
      lieu.left - offsetHori, cheque.top - offsetVerti);
    this.canvas_arrow(ctx, date.left - offsetHori, date.bottom - offsetVerti,
      date.left - offsetHori, cheque.top - offsetVerti);

    this.canvas_arrow(ctx, montantChiffre.left - offsetHori + (montantChiffre.width / 2) - 80,
      montantChiffre.bottom - offsetVerti,
      montantChiffre.left - offsetHori + (montantChiffre.width / 2) - 80,
      cheque.top - offsetVerti);
    ctx.stroke();

    ctx.beginPath();
    ctx.strokeStyle = '#E43A45';
    this.canvas_arrow(ctx, montantLettre1.left - offsetHori, montantLettre1.bottom - offsetVerti,
      cheque.left - offsetHori, montantLettre1.bottom - offsetVerti);
    this.canvas_arrow(ctx, montantLettre2.right - offsetHori, montantLettre2.bottom - offsetVerti,
      cheque.left - offsetHori, montantLettre2.bottom - offsetVerti);
    this.canvas_arrow(ctx, destinataire.left - offsetHori, destinataire.bottom - offsetVerti,
      cheque.left - offsetHori, destinataire.bottom - offsetVerti);
    this.canvas_arrow(ctx, lieu.left - offsetHori, lieu.bottom - offsetVerti,
      cheque.left - offsetHori, lieu.bottom - offsetVerti);
    this.canvas_arrow(ctx, date.left - offsetHori, date.bottom - offsetVerti,
      cheque.left - offsetHori, date.bottom - offsetVerti);

    this.canvas_arrow(ctx, montantChiffre.left - offsetHori + (montantChiffre.width / 2) - 80,
      montantChiffre.bottom - offsetVerti,
      cheque.left - offsetHori,
      montantChiffre.bottom - offsetVerti);

    ctx.stroke();
    ctx.beginPath();
  },
};
</script>
